//import natural from './images/naturalstatic.png';
import React from 'react';
import Lottie from "lottie-react";

import natural from './natural_animation.json';


export default function About() {
	return (
	<>
	  <meta name="description" content="Experience natural, drug-free relief with Senior Relief Spray. A 25-oil blend with Hempseed & Arnica for pain relief, mobility, and deep sleep support." />
  <meta name="keywords" content="senior relief spray, hempseed oil, arnica montana, natural pain relief, anti-inflammatory spray, muscle joint relief, sleep support, chemical free remedy" />
  <meta name="author" content="Senior Spray" />
	<div id='about'>
	 <Lottie animationData={natural} loop={true} style={{width: '150px', height: '147px', float: 'left', 'padding-right': '10px'}}/>

		<b className='blue bold underline'>SENIOR RELIEF SPRAY</b> <b className='bold blue'>250ml - </b><b className='red italic bold'>*** Never use inside the body ***</b>
		<br />
		<br />

		<p className='purple'>
			With the soothing ingredients of anti-inflammatory Hempseed Oil & the pain relieving properties of Arnica Montana, & 22 other anti-inflammatory healing oils from nature, Senior relief spray is formulated to give relief for 2-4 hours per application & even longer if you use our additional healing spray point tips.   Hempseed Oil is both nutritional & a natural anti-inflammatory.  It penetrates easily into your skin with gentle circular massage & starts to work its magic within 5-10 min.
		</p>

		<br />

		<span className='inline brightpurple underline bold'>
			Arnica Montana &nbsp; 
		</span> 
		<p className='purple inline'>
			has been used medicinally since the early 1500's for muscle & joint pain & speeds up healing time with broken bones & sprains. This perfect blend of 25 healing plant oils is the perfect recipe for most anything relaxing the nervous system.  The nervous system relaxer oils have helped many experience a deeper REM sleep state for longer.  Both falling asleep, staying asleep & no more waking in the middle of the night!  If this does happen occasionally, just a few trigger point sprays on the body & you are falling back to sleep with ease in no time..
		</p>

		<br />
		<br />

		<p className='purple italic'>
			*Note: For chronic conditions we recommend another application after 1/2 hour & intial use is recommended two times a day  (upon waking & before bed) or an additional as needed mid day.
		</p>

		<br/ >

		<p className='brightpurple bold inline'>
			<span><u>Healing from Nature </u></span>
			<b className='blue'>
					Drug Free relief spray must be your go to remedy because it's both non addictive, chemical free & yet effective no matter how often you use.  ( Unlike mainstream drugs or CBD  whereby your body builds up a resistance or reaches a plateau & is no longer providing prior relief )  Our product is economically superior in comparison to CBD & prescriptions.  Spray form has a vaster body coverage with a much longer dispersal use time overall.
        	</b>
		</p> 

		<br />
		<br />
		<p>
		 <small className='blue bold'>
		 	Upon Purchase you can download our healing cheat sheet for the meridian trigger point spray application spots for even longer lasting relief.
		 </small>
		</p>
		<br />
		<br />
	<p style={{fontSize: 10, 'font-weight': 'bold'}} >
		Disclaimer:  We make no claims on this product.  This is not a medicine & not intended to be offered as a cure for any issue(s).  The information on this website has not been evaluated by the Canadian Food Inspection Agency or the FDA. We do not aim to diagnose, treat, cure or prevent any disease. Information is shared for educational purposes only. .  All are meant for research, or experimental.
		</p>
	</div>
	</>
	);
}
